module.exports = __webpack_public_path__ + "static/media/submitter-log-orange.a2d9fe01.svg";